exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-wrapper[data-v-b4fd2928]{display:flex;justify-content:flex-end}", ""]);

// exports
